/**
 * 语言切换器 - 原生选择器形式
 * 使用 HTML select 元素
 */

import { ChevronDown } from 'lucide-react';
import { useTranslation } from '../../useTranslation';
import { useLanguageNavigation } from '../../hooks/useLanguageNavigation';
import type { ActiveLanguage } from '../../types';
import type { SizeClasses } from './types';

interface SelectProps {
  sizeClasses: SizeClasses;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Select({ sizeClasses, size = 'md', className = '' }: SelectProps) {
  const { language, availableLanguages } = useTranslation();
  const { changeLanguage } = useLanguageNavigation();

  return (
    <div className={`relative ${className}`}>
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value as ActiveLanguage)}
        className={`
          appearance-none bg-[var(--y-surface-secondary)]/50 border border-[var(--y-border)] rounded-lg
          text-[var(--y-text-primary)] cursor-pointer focus:outline-none focus:border-[var(--y-accent)]
          pr-8 ${sizeClasses[size]}
        `}
        aria-label="Select language"
      >
        {availableLanguages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.nativeName}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--y-text-tertiary)] pointer-events-none" />
    </div>
  );
}
